import React from 'react';
import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import type { FormText } from 'types/cms';

import TextField from '@material-ui/core/TextField';

/**
 * A multi-line text input suitable for capturing larger data e.g a message in a contact form
 * @param control
 * @param identifier
 * @param label
 * @param max_length
 * @param required
 * @constructor
 */
const TextAreaLong = ({
  control,
  identifier,
  label,
  max_length,
  required,
}: FormText & { control: Control }) => {
  return (
    <Controller
      name={identifier}
      control={control}
      defaultValue=""
      render={props => (
        <TextField
          {...props}
          label={label}
          required={required}
          multiline
          minRows={2}
          maxRows={10}
          inputProps={{ maxLength: max_length, 'data-testid': identifier }}
          autoComplete={'off'}
        />
      )}
    />
  );
};

export default TextAreaLong;
